export default () => import(/* webpackChunkName: 'coffee/app/agreement/unregister-instructions' */ './UnregisterInstructions');
